module.exports = __webpack_public_path__ + "static/media/headCharacter.f3fea96f.png";